/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Aspect_Ratio_LabelInputs */

const en_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect Ratio`)
};

const fr_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format d'image`)
};

const de_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenverhältnis`)
};

const it_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporzioni`)
};

const ru_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соотношение сторон`)
};

const es_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relación de aspecto`)
};

const zh_cn2_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长宽比`)
};

const ja_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アスペクト比`)
};

const hi_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आस्पेक्ट अनुपात`)
};

const pt_pt2_media_import_aspect_ratio_label = /** @type {(inputs: Media_Import_Aspect_Ratio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporção da tela`)
};

/**
* | output |
* | --- |
* | "Aspect Ratio" |
*
* @param {Media_Import_Aspect_Ratio_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_aspect_ratio_label = /** @type {((inputs?: Media_Import_Aspect_Ratio_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Aspect_Ratio_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_aspect_ratio_label(inputs)
	if (locale === "de") return de_media_import_aspect_ratio_label(inputs)
	if (locale === "it") return it_media_import_aspect_ratio_label(inputs)
	if (locale === "ru") return ru_media_import_aspect_ratio_label(inputs)
	if (locale === "es") return es_media_import_aspect_ratio_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_aspect_ratio_label(inputs)
	if (locale === "ja") return ja_media_import_aspect_ratio_label(inputs)
	if (locale === "hi") return hi_media_import_aspect_ratio_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_aspect_ratio_label(inputs)
	return en_media_import_aspect_ratio_label(inputs)
});